import { DrillDownService } from 'client/js/main/components/DrillDownTable/services';
import type { DrillDownState } from './DrillDown.types';
import { INIT_STATE } from './DrllDown.constants';
import type { DrillDownAction } from './actions';
import { GET_DRILL_DOWN_DATA, RESET_DRILL_DOWN_ACTION, RESET_DRILL_DOWN_DATA, SET_LOADER_FOR_ROW } from './actions';

const handler = (state: DrillDownState = INIT_STATE, action: DrillDownAction = RESET_DRILL_DOWN_ACTION): DrillDownState => {
  let drillDownKey: string;

  switch (action.type) {
    case SET_LOADER_FOR_ROW:
      drillDownKey = DrillDownService.getDrillDownKey(action.data.filters);

      return {
        ...state,
        data: { ...state.data, [drillDownKey]: { isLoading: true } },
      };

    case GET_DRILL_DOWN_DATA.response:
      drillDownKey = DrillDownService.getDrillDownKey(action.data.filters);

      return {
        ...state,
        data: { ...state.data, [drillDownKey]: { data: action.data.data, isLoading: false } },
      };

    case RESET_DRILL_DOWN_DATA:
      return INIT_STATE;

    default:
      return state;
  }
};

export default handler;
